export function formatTimestamp(date) {
  const parsedDate = new Date(Date.parse(date));
  const formattedDate = parsedDate.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const formattedTime = parsedDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${formattedDate} at ${formattedTime}`;
}

export function formatDate(date) {
  return new Date(Date.parse(date)).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function isValidDate(dateString) {
  return new Date(dateString).toString() !== 'Invalid Date';
}
